
{{each $data.data as value}}
    {{if $data.type == 5 }}
        <a href="/resource/detail?id={{ value.id }}" target="_blank">
            <p class="tag">{{ value.source_name }}</p>
        </a>
    {{else}}
        <a href="/resource/detail?id={{ value.id }}" target="_blank" class="list-item-video {{$data.type !== 1 ? 'no-icon': ''}}">
            <div class="img">
                <i class="star {{ value.collect == 1 ?'active':'' }}"></i>
                <img src="{{ value.logo }}" alt="">
            </div>
            <div class="text-box">
                <p class="title row1">{{ value.source_name }}</p>
                <p class="company row1"><img src="{{ value.head }}" alt="">{{ value.author }}</p>
            </div>
        </a>
    {{/if}}
{{/each}}